import { SERVICES } from "@/data/content";
import { Money, ChartLineUp, MagnifyingGlass, ShieldCheck, MapPinLine, Headset, ArrowUpRight } from "@phosphor-icons/react";

const ICONS = { Money, ChartLineUp, MagnifyingGlass, ShieldCheck, MapPinLine, Headset };

export const Services = () => {
  return (
    <section id="services" data-testid="services-section" className="py-24 lg:py-32 bg-white border-t border-slate-200">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="max-w-2xl">
          <span className="overline text-[#B91C1C]">What we do</span>
          <h2 className="mt-4 font-serif-display text-3xl lg:text-4xl font-bold tracking-tight text-slate-900">
            A full-stack recovery capability
          </h2>
          <p className="mt-5 text-slate-600 leading-relaxed">
            From soft-bucket reminders to legal enforcement, we deploy the right recovery channel for every
            stage of delinquency — always within regulatory guardrails.
          </p>
        </div>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 border-t border-l border-slate-200">
          {SERVICES.map((s) => {
            const Icon = ICONS[s.icon];
            return (
              <div
                key={s.key}
                data-testid={`service-card-${s.key}`}
                className="group relative border-r border-b border-slate-200 p-8 lg:p-10 bg-white hover:bg-slate-50 transition-colors duration-200"
              >
                <Icon weight="duotone" className="h-10 w-10 text-slate-900" />
                <h3 className="mt-6 font-serif-display text-xl font-semibold text-slate-900">{s.title}</h3>
                <p className="mt-3 text-sm text-slate-600 leading-relaxed">{s.desc}</p>
                <ArrowUpRight className="absolute top-8 right-8 h-5 w-5 text-slate-300 group-hover:text-[#B91C1C] transition-colors duration-200" />
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
